<span class="quick-bet__taxation-info-za--truncate" *ngIf="showTaxation$ | async">{{ taxationInfo }}</span>
